import styles from './style.module.css';
import React from 'react';

interface LoadingSpinnerProps {
    message?: string;
}

export function LoadingSpinner({
    message,
}: LoadingSpinnerProps): React.ReactElement {
    return (
        <div
            className={styles.container}
            role="status"
            aria-live="polite"
            aria-busy="true"
        >
            <div className={styles.spinner} aria-hidden="true" />
            <span>{message}</span>
        </div>
    );
}
